import { BrowserRouter } from 'react-router-dom'
import React from 'react'
import { Provider } from 'react-redux'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import configureStore from './configureStore'
import * as serviceWorker from './serviceWorker'
import * as Buffer from 'buffer'
window.Buffer = Buffer.Buffer
import '@lynx/client-core/src/index.css'
import './index.css'
import { Logger } from '@lynx/client-core/src/modules/Logger'

const initialState = window.initialReduxState
const store = configureStore(initialState)
const container = document.getElementById('root')

if (!container) Logger.error('root element not found')
else {
	const root = createRoot(container)
	root.render(
		<Provider store={store}>
			<BrowserRouter>
				<App />
			</BrowserRouter>
		</Provider>
	)
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
